module.exports = __webpack_public_path__ + "img/BroadcastNotification.f0d479a.png";